__turbopack_context__.v({
  "shippingRestrictionMessageContainer": "ShippingRestrictionMessage-module-scss-module__0HEGkW__shippingRestrictionMessageContainer",
});
